import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import BlockIcon from '@mui/icons-material/Block';
import BuildIcon from '@mui/icons-material/Build';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import {CreditRequestStatusEnum} from '../../../model/credit/credit-request-status.enum';

export namespace CreditRequestUtils {
  export const priorityOptions = [
    {value: 'LOW', label: 'Niski'},
    {value: 'NORMAL', label: 'Normalny'},
    {value: 'HIGH', label: 'Wysoki'}
  ]

  export const getStatusIcon = (status: CreditRequestStatusEnum): React.ElementType => {
    switch (status) {
      case CreditRequestStatusEnum.NEEDS_ESTIMATION: return HourglassEmptyIcon
      case CreditRequestStatusEnum.WAITING_CUSTOMER_ACCEPTANCE: return HourglassBottomIcon
      case CreditRequestStatusEnum.ESTIMATE_REJECTED: return BlockIcon
      case CreditRequestStatusEnum.SCHEDULED: return EventAvailableIcon
      case CreditRequestStatusEnum.IN_PROGRESS: return BuildIcon
      case CreditRequestStatusEnum.PAUSED: return PauseCircleIcon
      case CreditRequestStatusEnum.RESOLVED: return CheckCircleIcon
      case CreditRequestStatusEnum.CANCELLED: return CancelIcon
      default: return HelpOutlineIcon
    }
  }

  export const getStatusIconColor = (status: CreditRequestStatusEnum): string => {
    switch (status) {
      case CreditRequestStatusEnum.NEEDS_ESTIMATION: return '#FF7074'
      case CreditRequestStatusEnum.WAITING_CUSTOMER_ACCEPTANCE: return '#FFA726'
      case CreditRequestStatusEnum.ESTIMATE_REJECTED: return '#FF7074'
      case CreditRequestStatusEnum.SCHEDULED: return '#1976D2'
      case CreditRequestStatusEnum.IN_PROGRESS: return 'gray'
      case CreditRequestStatusEnum.PAUSED: return '#FFA726'
      case CreditRequestStatusEnum.RESOLVED: return 'green'
      case CreditRequestStatusEnum.CANCELLED: return '#999'
      default: return '#1E3A8A'
    }
  }

  export const isHalfStep = (value: number): boolean => {
    if (isNaN(value)) return false
    return Math.abs((value * 2) - Math.round(value * 2)) < 1e-9 && value >= 0
  }
}
